
const TiposPagadorRecebedor = {
   Pagador: 1,
   Recebedor: 2,
   Ambos: 3
}

export default TiposPagadorRecebedor;